import CrudActionSetBase from './CrudActionSetBase'

export class OrganisationRoleActionSet extends CrudActionSetBase('organisationRole'){}
export default new OrganisationRoleActionSet()